import * as signalR from "@microsoft/signalr";
import { API_BASE_URL } from "../core/api-base-url";

class DialogSignalRService {
  constructor() {
    this.connection = null;
    this.isConnected = false;
    this.starting = null;
    this.receiveListeners = new Set();
    this.stateListeners = new Set();
  }

  onReceive(handler) {
    this.receiveListeners.add(handler);
    return () => this.receiveListeners.delete(handler);
  }

  onStateChange(handler) {
    this.stateListeners.add(handler);
    handler(this.isConnected);
    return () => this.stateListeners.delete(handler);
  }

  _setConnected(value) {
    this.isConnected = value;
    this.stateListeners.forEach((fn) => fn(value));
  }

  async _buildConnection() {
    if (this.connection) return;

    const hubUrl = `${String(API_BASE_URL || "").replace(/\/+$/, "")}/hubs/chat`;
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(hubUrl, {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets
      })
      .withAutomaticReconnect([0, 2000, 5000, 10000])
      .configureLogging(signalR.LogLevel.Error)
      .build();

    this.connection.on("ReceiveMessage", (messageDto) => {
      this.receiveListeners.forEach((fn) => fn(messageDto));
    });

    this.connection.onreconnecting(() => this._setConnected(false));
    this.connection.onclose(() => this._setConnected(false));
    this.connection.onreconnected(() => this._setConnected(true));

    await this.connection.start();
    this._setConnected(true);
  }

  async joinCompany(sessionId) {
    if (!sessionId) return;
    if (this.isConnected && this.connection) return;
    if (this.starting) {
      await this.starting;
      return;
    }
    this.starting = (async () => {
      await this._buildConnection();
      await this.connection.invoke("JoinCompany", sessionId);
    })();
    try {
      await this.starting;
    } catch (error) {
      this._setConnected(false);
      throw error;
    } finally {
      this.starting = null;
    }
  }

  async stop() {
    if (!this.connection) return;
    try {
      this._setConnected(false);
      await this.connection.stop();
    } finally {
      this.connection = null;
    }
  }
}

export default new DialogSignalRService();
